const denylist = [
  "episerver/cms",
  "axfood.local",
  "axfood.com.local",
  "dagab.local",
  "localhost",
];

function datalayerPush(event: string, data?: any) {
  const parameters = Object.assign({ event }, data);

  const currentUrl = window.location.href.toLowerCase();
  const preventGTM = denylist.some((url) => currentUrl.includes(url));

  if (window && window.dataLayer && !preventGTM)
    window.dataLayer.push(parameters);
}

export default { datalayerPush };
